import { callGetApiToServer } from "../callApi";

export async function getAllOpenApiUsers(
  authtoken,
  flag,
  skipNumber,
  limitNumber,
  city = null
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = `v1/auth/list-user/${skipNumber}/${limitNumber}?account_type=${flag}`;
    if (city) {
      endUrl += `&city=${city}`;
    }

    let responseData = await callGetApiToServer(header, "GET", endUrl);
    return responseData;
  } catch (err) {
    throw err;
  }
}
